import * as fetcher from '../helpers/fetcher';

export async function clientHubLogin(email: string, password: any) {
  try {
    return fetcher.post(`/admin/auth/gamehub-login`, {}, { email, password });
  } catch (error: any) {
    throw new Error(error.message);
  }
}
